// React import and other libs
import React, {useEffect, useState} from "react";
import axios from "axios";
import WebApp from "@twa-dev/sdk";
// Import hooks
import { apiRequests } from "../../hooks/apiRequests";
// Import styles
import "./Upgrade.css";
// Import of constants
import {
    BASE_URL,
    BASIC,
    FREE,
    PREMIUM,
    PRICES,
    PRO, RESTORE,
    RESTORE_ENERGY,
    RESTORE_PRICES,
    UPGRADE_AI_LEVEL,
    UPGRADE_SUBSCRIPTION_BASIC,
    UPGRADE_SUBSCRIPTION_PREMIUM,
    UPGRADE_SUBSCRIPTION_PRO,
    XTR
} from "../../consts/consts";

// Button for pay (telegram stars)
function PayStarsButton(props) {

    const baseUrl = BASE_URL; // Backend bot URL for generate invoice link
    const [isToggled, setIsToggled] = useState(false); // State for click generate invoice link

    // Async sleep for notification
    function sleep(ms){
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    // Payment analyzer
    useEffect(() => {
        const handleInvoiceClosed = async (event) => {

            const { getUserDataFromDb } = apiRequests(); // Hook for get new user state from backend DB
            const { status } = event;

            // Check status of payment
            if (status === "paid") {
                let resp = null;
                try {
                    props.setNotification("Updating user data...", 2500);
                    await sleep(2500); // Async sleep for waiting of update backend DB
                    let reqBody = {
                        'id': props.tgid,
                        'token': props.token
                    }
                    resp = await getUserDataFromDb(reqBody); // Get user data from backend DB
                    props.changeUserData(resp);
                    props.setNotification("Updated!", 1500);
                    setIsToggled(false);

                } catch (error) {
                    if (error.message === "403") {
                        props.setNotification("Invalid username/token. Refresh\npage and try again.", 2000);
                    } else if (error.message === "400") {
                        props.setNotification("Invalid request. Try again.", 2000);
                    } else {
                        props.setNotification("Error. Try again or contact support.", 2000);
                    }
                    setIsToggled(false);
                }
            } else if (status === "cancelled") {
                props.setNotification("Invoice cancelled.\nTry again or contact support.", 2000);
                setIsToggled(false);
            } else {
                props.setNotification("Error. Try again or contact support.", 2000);
                setIsToggled(false);
            }
        };

        WebApp.onEvent("invoiceClosed", handleInvoiceClosed);

        return () => {
            WebApp.offEvent("invoiceClosed", handleInvoiceClosed);
        };
    }, []);

    // Creating telegram stars payment invoice
    const handleLink = async (payload, setNotification) => {
        try {
            const response = await axios.post(`${baseUrl}/api/createInvoiceLink`, {
                payload: payload
            });
            if (response.data.success) {
                WebApp.openInvoice(response.data.invoiceLink, async (status) => {
                    if (status === "paid") {
                        setNotification("Invoice status: paid.", 2000);
                    }
                });
                setIsToggled(false);
            } else {
                setNotification("Error creating invoice.\nTry again or contact support.", 2000);
                setIsToggled(false);
            }
        } catch (error) {
            setNotification("An error occurred while\ncreating the invoice.\nTry again or contact support.", 2000);
            setIsToggled(false);
        }
    };

    // Handle of click generate invoice button
    const handleToggle = (payload, setNotification) => {
        if (isToggled === false) {
            handleLink(payload, setNotification);
            setIsToggled(true);
        }
    };

    const { type, aiLevel, subscription, tgid, setNotification } = props;

    let aiLevelInt = parseInt(aiLevel);
    const timestamp = Date.now();

    if (type === UPGRADE_AI_LEVEL) {
        if(aiLevelInt >=5) {
            return null;
        } else {
            const upgrade_type = "ai_level_" + (aiLevelInt+1).toString();

            const payload = tgid + ":" + upgrade_type + ":" + timestamp.toString();
            return (
                <div className={"upgrade__button"} onClick={() => handleToggle(payload, setNotification)}>
                    <span className="upgrade__button-text">
                        Upgrade to AI level {(aiLevelInt + 1).toString()} ({PRICES["AI_LEVEL_"+(aiLevelInt + 1)][XTR].toString()} ★)
                    </span>
                </div>
            );
        }
    } else if (type === UPGRADE_SUBSCRIPTION_BASIC){
        const payload = tgid + ":" + BASIC + ":" + timestamp.toString();
        return (
            <div className={"upgrade__button"} onClick={() => handleToggle(payload, setNotification)}>
                    <span className="upgrade__button-text">
                        Upgrade to Basic ({PRICES[BASIC.toUpperCase()][XTR].toString()} ★)
                    </span>
            </div>
        );
    } else if (type === UPGRADE_SUBSCRIPTION_PRO){
        const payload = tgid + ":" + PRO + ":" + timestamp.toString();
        return (
            <div className={"upgrade__button"} onClick={() => handleToggle(payload, setNotification)}>
                    <span className="upgrade__button-text">
                        Upgrade to Pro ({PRICES[PRO.toUpperCase()][XTR].toString()} ★)
                    </span>
            </div>
        );
    } else if (type === UPGRADE_SUBSCRIPTION_PREMIUM){
        const payload = tgid + ":" + PREMIUM + ":" + timestamp.toString();
        return (
            <div className={"upgrade__button"} onClick={() => handleToggle(payload, setNotification)}>
                    <span className="upgrade__button-text">
                        Upgrade to Premium ({PRICES[PREMIUM.toUpperCase()][XTR].toString()} ★)
                    </span>
            </div>
        );
    } else if (type === RESTORE_ENERGY){

        let price = 1;
        if (subscription === FREE) {
            price = RESTORE_PRICES["AI_LEVEL_"+aiLevelInt.toString()][XTR];
        } else if (subscription === BASIC || subscription === PRO || subscription === PREMIUM) {
            price = RESTORE_PRICES[subscription.toUpperCase()][XTR];
        }

        const payload = tgid + ":" + RESTORE + "_" + aiLevel + "_" + subscription  + ":" + timestamp.toString();
        return (
            <div className={"upgrade__button"} onClick={() => handleToggle(payload, setNotification)}>
                    <span className="upgrade__button-text">
                        Restore energy ({price.toString()} ★)
                    </span>
            </div>
        );
    }
    else {
        return null;
    }

}

export default PayStarsButton;